import React, { useEffect, useState } from "react";

import { zl } from "../../functions/utilities";
import { translate } from "../../functions/dictionary";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPrint } from '@fortawesome/free-solid-svg-icons'

const MieszkaniecDaneNaleznosci = props => {

    const { tablicaCzynsze_g, grupaUdzial, msc, setMsc, showPrint, rozliczenieWody, stawkiJednorazoweInd_u } = props;

    const [tablicaMsc, setTablicaMsc] = useState({});
    const [woda, setWoda] = useState(undefined);

    useEffect( () => {
        if (tablicaCzynsze_g?.length === 1) {
            setMsc(tablicaCzynsze_g[0].msc)
        }
        else if (tablicaCzynsze_g?.length > 1)
            setMsc(tablicaCzynsze_g[ tablicaCzynsze_g?.length - 1 ].msc)
    },[tablicaCzynsze_g, grupaUdzial])

    useEffect( () => setTablicaMsc( tablicaCzynsze_g?.find( t => t?.msc === msc) ),[msc, tablicaCzynsze_g, grupaUdzial])

    const handleMsc = e => setMsc(e.target.value);
    
    const miesiace = tablicaCzynsze_g?.map( (t, i) => (
        <option
            key={i}
            value={t.msc}
        >
            {t.msc}
        </option>
    ))

    const RentTable = () => {
        if (!tablicaMsc || typeof tablicaMsc !== "object") {
          return <p>Brak danych</p>;
        }
      
        const filteredEntries = Object.entries(tablicaMsc).filter(
          ([key, value]) => typeof value === "number" && !isNaN(value) && !key.includes("_podstawa") && value !== 0 && key !== "czynsz_na_msc"
        );
        // console.log(filter)
        return (
              filteredEntries?.map(([key, value]) => key !== "jednorazowaInd_kwota" && (
                <tr key={key} >
                    <td>{translate(key)}</td>
                    <td>{zl(value)}</td>
                </tr>
              )
        ))
    };
    
    useEffect( () =>{
        const temp = rozliczenieWody?.find( r => r?.miesiac == msc && r?.opublikowany == 1)
        const temp2 = temp?.procenty?.find( p => p?.id_user == grupaUdzial?.id_user && p?.grupa_numer == grupaUdzial?.grupa_numer );
        setWoda({opis: temp?.opis, saldo: temp2?.saldo})
    },[rozliczenieWody, msc, grupaUdzial])

    const indWiersz = stawkiJednorazoweInd_u?.length > 0 && stawkiJednorazoweInd_u?.map( (stawka, i) => (
        <tr key={i}>
            <td>{stawka.opis}</td>
            <td>{zl(stawka.kwota)}</td>
        </tr>
    ))
    
    const wodaWiersz = woda?.opis && (
        <tr>
            <td>{woda?.opis}</td>
            <td>{zl(woda?.saldo)}</td>
        </tr>
    )
    
    return (
        <div className="naleznosci ramka">
            <div className="naglowek">
                <h2>
                    Należności 
                </h2>
                <FontAwesomeIcon 
                    icon={faPrint} 
                    className='pointer'
                    onClick={showPrint}
                />
                <div>
                    <select 
                        value={msc}
                        onChange={handleMsc}
                    >
                        {miesiace}
                    </select>
                </div>
            </div>
            <div className="naleznosci ramka-inset-shadow">
                <table>
                    <thead>
                        <tr>
                            <th>
                                Opis
                            </th>
                            <th>
                                Kwota
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {RentTable(tablicaMsc)}
                        {indWiersz}
                        {wodaWiersz} 
                    </tbody>
                    <tfoot>
                        <tr>
                            <td>
                                Razem:
                            </td>
                            <td>
                                {zl(tablicaMsc?.czynsz_na_msc + (woda?.saldo || 0))}
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    )
}

export default MieszkaniecDaneNaleznosci;